import isShown from './is-shown';
import isLoaded from './is-loaded';

export default {
  isShown,
  isLoaded,
};
